import { capitalizeWords } from "../../../utils";

function getGreeting(hour: number): string {
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

interface DashboardGreetingProps {
  firstName?: string | null | undefined;
}

export default function DashboardGreeting({
  firstName,
}: DashboardGreetingProps) {
  const now = new Date();
  const greeting = getGreeting(now.getHours());
  const name = firstName ? capitalizeWords(firstName) : "there";
  const today = now.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-semibold text-primary">
        {greeting}, {name} <span className="inline-block">👋</span>
      </h1>
      <p className="mt-1 text-sm text-gray-500">
        Here&apos;s your money at a glance · {today}
      </p>
    </div>
  );
}
